import React from 'react'
import { connect } from 'react-redux'
import { localized } from '@/decorators/localized'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import LoadingIndicator from '@/components/LoadingIndicator'
import { actionCreators } from '@/store/ReportingGroups'
import { actionCreators as reportSubmittersActionCreators } from '@/store/ReportSubmitters'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import ReportingGroupDetailForm from './reportingGroupDetailForm'

@localized()
class ReportingGroupDetail extends React.Component {
  componentDidMount () {
    this.reload()
  }
  componentDidUpdate (prevProps, prevState) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.reload()
    }
  }
  reload () {
    this.props.get(this.props.match.params.id)
  }
  render () {
    const {
      localize,
      reportingGroups,
      update,
      reportSubmitters,
      removeInstitutionGroupReportSubmitter,
      removeInstitutionReportSubmitter,
      excludeInstitutionReportSubmitter,
      saveInstitutionReportSubmitter,
      saveInstitutionGroupReportSubmitter,
      openDialog } = this.props
    const isLoading = reportingGroups.fetching || reportingGroups.updating
    let title = ''
    if (!reportingGroups.fetching && reportingGroups.reportingGroup) {
      title = localize(reportingGroups.reportingGroup.forecasting ? 'Reporting.ForecastingReportingGroup' : 'Reporting.ReportingGroup')
    }
    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl='/reporting-groups'>
            {title}
          </MainTopTitle>
        </MainTop>
        <MainBody transparent>
          {isLoading && <LoadingIndicator />}
          {!isLoading && (
            <ReportingGroupDetailForm
              key={reportingGroups.componentKey}
              reportingGroup={reportingGroups.reportingGroup}
              update={update}
              removeInstitutionGroupReportSubmitter={removeInstitutionGroupReportSubmitter}
              removeInstitutionReportSubmitter={removeInstitutionReportSubmitter}
              reportSubmitters={reportSubmitters}
              excludeInstitutionReportSubmitter={excludeInstitutionReportSubmitter}
              saveInstitutionReportSubmitter={saveInstitutionReportSubmitter}
              saveInstitutionGroupReportSubmitter={saveInstitutionGroupReportSubmitter}
              openDialog={openDialog}
              match={this.props.match}
              onParametersSaved={() => this.reload()} />
          )}
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportingGroups: state.reportingGroups,
    reportSubmitters: state.reportSubmitters,
    ...ownProps
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  update: actionCreators.update,
  removeInstitutionGroupReportSubmitter: reportSubmittersActionCreators.removeInstitutionGroupReportSubmitter,
  removeInstitutionReportSubmitter: reportSubmittersActionCreators.removeInstitutionReportSubmitter,
  excludeInstitutionReportSubmitter: reportSubmittersActionCreators.excludeInstitutionReportSubmitter,
  saveInstitutionReportSubmitter: reportSubmittersActionCreators.saveInstitutionReportSubmitter,
  saveInstitutionGroupReportSubmitter: reportSubmittersActionCreators.saveInstitutionGroupReportSubmitter,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingGroupDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingGroups/reportingGroupDetail.js